<template>
  <ModalContainer 
    queryParam="view_aux" 
    ref="modalContainer"
    size="lg"
  >
    <b-card cols="12" class="w-90 mr-2">

      <h3 class="text-center">Información del Examen</h3>

      <div cols="12" class="mb-2" v-if="itemLab">
        <hr/>  

        <div> 
          <i class="fas fa-user" style="margin-right: 10px;"/> 
          <b>Paciente:</b> {{ itemLab.paciente.nombreTexto }}
        </div>
        
        <div> 
          <i class="fas fa-phone" style="margin-right: 10px;"/> 
          <b>Telefono - correo:</b> {{ itemLab.paciente.contacto }}
        </div>

        <hr>
        <div>
          <i class="fas fa-hospital" style="margin-right: 10px;"/>
          <b>Doctor:</b>  {{ itemLab.doctor }}
        </div>

        <div>
          <i class="fas fa-hospital" style="margin-right: 10px;"/>
          <b>Especialidad:</b>  {{ itemLab.especialidad }}
        </div>

        <div>
          <i class="fas fa-calendar" style="margin-right: 10px;"/>
          <b>Fecha:</b> {{ itemLab.fechaCita }}
        </div>

        

        <div>
          <i class="fas fa-vial" style="margin-right: 10px;"/>
          <b>Codigo Orden: </b> {{ itemLab.codigoOrden }}
        </div> 
        
        <div>
          <i class="fas fa-tag" style="margin-right: 10px;"/>
          <b>Codigo Orion: </b>{{ itemLab.codigoOrion || "No Disponible"}}
        </div>

      </div>


      <div v-if="itemLab">
        <hr>
        <div class="mb-1"> 
          <i class="fas fa-briefcase-medical mr-1"/> 
          <b>Exámenes:</b> 
        </div>

        <b-alert 
          show 
          variant="secondary" 
          class="my-2 p-1 position-relative"
        >
          <b-row class="d-flex align-items-center mt-1">

            <div class="col">
              <div 
                v-for="(lab, index) in itemLab.laboratorios" 
                :key="index"
                class="text-secondary"
              >
                - {{ lab.text }}
              </div>
            </div>
            
          </b-row>
        </b-alert>
      </div>
      <div v-if="itemLab">
        <hr>
        <h6>Documentos:</h6>

        <div 
          v-if="itemLab.mspPaciente" 
          class="mb-1"
        >
          <b>MSP Paciente: </b> 
          <b-button 
            size="sm"
            variant="warning" 
            @click="onViewFiles(itemLab.mspPaciente)"
          >
            <i class="fa-solid fa-file"/>
          </b-button>
        </div>

        <div 
          v-if="itemLab.mspTitular1"
          class="mb-1"
        >
          <b>MSP Titular 1: </b> 

          <b-button 
            size="sm"
            variant="warning" 
            @click="onViewFiles(itemLab.mspTitular1)"
          >
            <i class="fa-solid fa-file"/>
          </b-button>


        </div>

        <div 
          v-if="itemLab.mspTitular2"
          class="mb-1"
        >
          <b>MSP Titular 2: </b> 
          <b-button 
            size="sm"
            variant="warning" 
            @click="onViewFiles(itemLab.mspTitular2)"
          >
            <i class="fa-solid fa-file"/>
          </b-button>
        </div>
        <!-- aqui va a mostrarse el boton para descagar form 13A -->
        <div
          v-if="canViewForm13(itemLab.laboratorios, itemLab.estadoLaboratorio)"
          class="mb-1" 
        >
          <b-button 
            size="sm"
            variant="warning"  
            @click="descargarForm13A(itemLab.id)"
          >
            <i class="fa-solid "/>13A
          </b-button>
        </div>
        <div
          v-if="itemLab.urlInforme && itemLab.urlInforme.length>0"
          class="mb-1" 
        >
          <b-button 
            size="sm"
            @click="downloadReportId(itemLab.urlInforme)"
          >
            <i class="fas fa-id-card" style="margin-right: 10px;" title="resultados" />
          </b-button>
        </div>
      </div>

      <hr>

      <!--<div v-if="itemsLs4">
        <b>Resultados:</b>
        <span v-if="!itemsLs4.resultados"> No hay resultados disponibles </span>
        <b-button
          v-if="itemsLs4.resultados"
          size="sm"
          variant="success" 
          @click="onViewFiles(itemsLs4.resultados)"
        >
          <i class="fa-solid fa-file"/>
        </b-button>
      </div> 

      <ModalViewFile
        v-if="fileToView"
        :urlFile="fileToView"
        v-model="isModalFileVisible"
      />

      <GeneralLoader v-if="isLoading"  class="my-5"/> -->

    </b-card> 

    <ModalViewFile
      v-if="fileToView"
      :urlFile="fileToView"
      v-model="isModalFileVisible"
    />
  </ModalContainer>
</template>

<script>
import { ModalContainer, ModalViewFile } from "@/shared/components";
import { getEstablecimientoLS, } from "@/shared/helpers";
import rutas from '@/assets/utils/rutas.json';
import axios from 'axios';
import actions from '@/assets/utils/utils';
import { labAs400Service } from '../../services';
import { labAuxiliarService } from '../../services';
import { labAuxMapper } from "../../helpers";

export default {

  name: "ViewDetailsAux",

  components: {
    ModalContainer,
    ModalViewFile
  },

  async created(){
    this.getData();
    await this.loadDataInit();
  },


  data() {
    return {
      tokenAuxiliar: null,

      itemLab: null,
      fileToView: null,
      isModalFileVisible: false
    }
  },


  methods: {

    async loadDataInit() {

      // buscar los ids en la cartera que tenga el codigo 390001 que es el examen que necesita el form13
      const CODIGOS_FORM13 = ['390001'];
      const establecimiento = getEstablecimientoLS();
      const resultsLabForm13 = await Promise.all(
        CODIGOS_FORM13.map(
          codigo => labAs400Service.searchLab(codigo, establecimiento.id)
        )
      );

      this.idsForm13 = resultsLabForm13.flatMap(result => result[0].id);
    },
    downloadReportId(downloadUrl) {
      this.fileToView = downloadUrl;
      this.isModalFileVisible = true;
    },
    async getData(){

      this.itemLab = null;

      this.tokenAuxiliar = this.$route.query.view_aux;
      if(!this.tokenAuxiliar) return;
      const responseSearch = await labAuxiliarService.getAll({ tokenLaboratorio: this.tokenAuxiliar });
      if(!responseSearch || !responseSearch.data?.length) {
        await this.$swal({
          icon: 'error',
          title: 'No se encontro el auxiliar',
          showConfirmButton: true,
        });
        this.$refs.modalContainer.closeModal();
        return;
      }
      const dataLab = labAuxMapper(responseSearch.data[0]);
      this.itemLab = dataLab;
    },
    canViewForm13(idsLaboratorios, estadoLaboratorio) {
      // Verificar si idsLaboratorios es un array, si no, convertirlo a un array
      const laboratorios = Array.isArray(idsLaboratorios) ? idsLaboratorios : [idsLaboratorios];
      // Comprobar si algún id de idsForm13 coincide con el id de algún objeto en laboratorios
      const existeCitologia = this.idsForm13.some(id => laboratorios.some(lab => lab.id === id));
      const estadoValido = parseInt(estadoLaboratorio) > 1;
      return estadoValido && existeCitologia;
    },
    async descargarForm13A(idLaboratorio) {
      const query = `
        query MyQuery {
          generateForm013a(idLab: ${idLaboratorio}) {
            message
            pdfBase64
            status
            nombres
            identificacion
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        if (response.data.data.generateForm013a.pdfBase64) {
          const item = response.data.data.generateForm013a.pdfBase64;
          const nombres = response.data.data.generateForm013a.nombres;
          const identificacion = response.data.data.generateForm013a.identificacion;

          actions.cargarArchivos(
            item,
            "solicitudLaboratorio_" + `${identificacion}-${nombres}-${idLaboratorio}` + ".pdf",
            "data:application/pdf;base64"
          );
        } else {
          this.$swal({
            title: "Error",
            text: "El archivo no existe, comunicar con el adminsitrador sistema",
            icon: "error",
            confirmButtonColor: "#089599",
          });
        }
      } catch (error) {
        console.error(error);
        this.$swal({
          title: "Error",
          text: "Error al descargar el archivo",
          icon: "error",
          confirmButtonColor: "#089599",
        });
      }
    },

    onHidden() {
      this.isVisible = false;
    },


    onViewFiles(url) {
      this.fileToView = url;
      this.isModalFileVisible = true;
    },

  },


  watch: {

    '$route.query.view_aux': {
      handler(){
        this.getData();
      },
    },
  },


}
</script>